import React from 'react';
import Fade from '@material-ui/core/Fade';
import CircularProgress from '@material-ui/core/CircularProgress';

const styles = {
  center: {
    position: 'fixed',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    margin: 'auto'
  },
  main: {
    height: '94%'
  }
};

const delay = delay => ({ transitionDelay: `${delay || '800'}ms` });

const Loading = props => (
  <div style={styles.main}>
    <Fade
      in={true}
      style={Object.assign(props.style || styles.center, delay(props.delay))}
      unmountOnExit
    >
      <CircularProgress size={props.size} />
    </Fade>
  </div>
);

export default Loading;
